"use strict";
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreferReturn = exports.OrderByOperator = void 0;
/** Entity list ordering operators that are supported in $orderBy url parameter. */
var OrderByOperator;
(function (OrderByOperator) {
    /** Ascending. Entities will be returned in ascending order. */
    OrderByOperator["Ascending"] = "asc";
    /** Descending. Entities will be returned in descending order. */
    OrderByOperator["Descending"] = "desc";
})(OrderByOperator = exports.OrderByOperator || (exports.OrderByOperator = {}));
/**
 * Values for return preference used in `Prefer` header. The header value is formed by joining
 * `return=` and the enum value.
 */
var PreferReturn;
(function (PreferReturn) {
    /** Instructs the server to return minimal entity representation. */
    PreferReturn["Minimal"] = "minimal";
    /** Instructs the server to return full entity representation. */
    PreferReturn["Representation"] = "representation";
})(PreferReturn = exports.PreferReturn || (exports.PreferReturn = {}));
//# sourceMappingURL=CommonInterfaces.js.map